import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getTranslateMarkupKey } from '../../utils/keys';
export const useTranslateMarkup = (options) => {
    const { variables, useQueryOptions } = options;
    const { client } = useTribeClient();
    const exportRequestKey = getTranslateMarkupKey({ variables });
    return useQuery(exportRequestKey, () => client.query({
        name: 'translateMarkup',
        args: {
            variables,
        },
    }), useQueryOptions);
};
//# sourceMappingURL=useTranslateMarkup.js.map